import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/api/queryKeys';
import { getTree, getSubtree, type TreeData } from '@/api/tree.api';

// ─── Gesamter Baum ──────────────────────────────────────────────────────────

/**
 * Lädt den gesamten Stammbaum (Nodes + Links).
 * Kein automatisches Polling – Daten werden bei Bedarf durch
 * Mutation-Invalidierung (useCreatePerson etc.) aktualisiert.
 */
export function useTree() {
  return useQuery<TreeData>({
    queryKey: QUERY_KEYS.tree.all,
    queryFn: getTree,
    refetchInterval: 0,
  });
}

// ─── Teilbaum ───────────────────────────────────────────────────────────────

/**
 * Lädt den Teilbaum ab einer bestimmten Person.
 * @param personId - Ausgangsperson
 * @param depth - Generationen in beide Richtungen (default: 3)
 */
export function useSubtree(personId: string | null, depth: number = 3) {
  return useQuery<TreeData>({
    queryKey: QUERY_KEYS.tree.subtree(personId!, depth),
    queryFn: () => getSubtree(personId!, depth),
    enabled: !!personId,
  });
}
